export default function(state = null, action) {
  switch(action.type) {
    case 'STORE_ITEMS':
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/store_items.js